export const crmContactsArticle = {
  title: 'Customer CRM: Contacts',
  slug: 'crm-contacts',
  content: `Customer CRM: Contacts

The Contacts tab is where you capture individuals and track their lifecycle stage.

1) Navigate to Contacts
- From /crm, select the Contacts tab ("Contacts").
- Use the view switcher to toggle between Table, Kanban, and Gallery views.

2) Search + filters
- Use the search bar to find contacts by name or email.
- Filter by lifecycle stage to focus on Leads, Opportunities, or Customers.

3) Add a contact quickly
- Use Quick Add for fast entry. First name and email are required.
- Use Full Form to capture phone, address, lifecycle stage, and notes.

4) View contact details
- Open a contact record using the View button.
- Review profile details and related activity from the detail page.

5) Create a deal from a contact
- Use the + Deal action on a contact to create a new opportunity.
- The deal will be linked to the contact automatically.
`,
};
